var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('span',[(_vm.value == 1)?_c('span',{staticClass:"text-error"},[_vm._v(" Hoog ")]):(_vm.value==2)?_c('span',[_vm._v(" Normaal ")]):_c('span',[_vm._v(" Laag ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }